import type {ApplicationServices} from './types/services'
import React from 'react'
import {createRoot} from 'react-dom/client'
import {Provider as ReduxProvider} from 'react-redux'
import {StyledEngineProvider} from '@mui/material/styles'
import {configureStore} from './store/reduxStore'
import App from './App'
import {CloudFunctionsServiceContext} from './backend/CloudFunctionsServiceContext'
import {ApplicationServicesContext} from './backend/ApplicationServicesContext'

export const renderApp = (services: ApplicationServices) => {
  const container = document.getElementById('root')
  if (!container) throw new Error('Application root is missing.')
  const root = createRoot(container)
  root.render(
    <React.StrictMode>
      <ReduxProvider store={configureStore()}>
        <StyledEngineProvider injectFirst>
          <ApplicationServicesContext.Provider value={services}>
            <CloudFunctionsServiceContext.Provider value={services.cloudFunctionsService}>
              <App/>
            </CloudFunctionsServiceContext.Provider>
          </ApplicationServicesContext.Provider>
        </StyledEngineProvider>
      </ReduxProvider>
    </React.StrictMode>
  )
  return root
}
